const CLAVE = "fenix_sello";

/**
 * El sello con el que se bajaron los datos que hoy tiene guardados el navegador.
 * Se lo trata como valor OPACO: no se parsea ni se ordena, solo se compara por igualdad. Asi el
 * back puede mandar un ISO, un rowversion o un hash sin que cambie nada aca, y el reloj del
 * celular deja de importar (comparar "mi fecha es menor que la del back" dependeria de la hora y
 * el huso del dispositivo).
 */
export class SelloLocal {
  static leer() {
    try {
      return localStorage.getItem(CLAVE);
    } catch {
      return null;
    }
  }

  static guardar(sello) {
    try {
      localStorage.setItem(CLAVE, String(sello));
    } catch {}
  }

  static limpiar() {
    try {
      localStorage.removeItem(CLAVE);
    } catch {}
  }

  /**
   * true = el back tiene novedades y hay que bajar datos de nuevo.
   * Sin sello del back (endpoint caido o mal implementado) devuelve false: es preferible mostrar
   * lo guardado antes que refrescar en cada pantalla. El boton ↻ del home sigue forzando la baja.
   */
  static hayCambio(selloBack) {
    if (!selloBack) return false;
    return selloBack !== this.leer();
  }
}
